import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Store, CheckCircle2, Clock, Ban, Sparkles, CreditCard, IndianRupee, AlertTriangle, CalendarClock } from "lucide-react";
import { format } from "date-fns";
import { api, money } from "@/lib/api";
import { Loader, PageHeader } from "@/components/common/Primitives";
import { StatusBadge } from "@/components/common/StatusBadge";
import { Stat } from "@/pages/owner/Overview";

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <Loader />;
  return (
    <div>
      <PageHeader title="Platform overview" subtitle="All restaurants, subscriptions and verified revenue." />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat icon={Store} label="Restaurants" value={s.total_restaurants} testId="admin-stat-total" />
        <Stat icon={CheckCircle2} label="Active" value={s.active} testId="admin-stat-active" />
        <Stat icon={Clock} label="Pending approval" value={s.pending} testId="admin-stat-pending" />
        <Stat icon={Ban} label="Suspended / rejected" value={`${s.suspended} / ${s.rejected}`} testId="admin-stat-suspended" />
        <Stat icon={Sparkles} label="On trial" value={s.active_trials} testId="admin-stat-trials" />
        <Stat icon={CreditCard} label="Paid subscriptions" value={s.active_subscriptions} testId="admin-stat-paid" />
        <Stat icon={CalendarClock} label="Expiring in 7 days" value={s.expiring_soon} testId="admin-stat-expiring" />
        <Stat icon={IndianRupee} label="Verified revenue" value={money(s.verified_revenue)} testId="admin-stat-revenue" />
      </div>
      {s.failed_payments > 0 && (
        <p className="mt-4 flex items-center gap-2 text-sm text-rose-600"><AlertTriangle className="h-4 w-4" />{s.failed_payments} failed payments</p>
      )}
      <div className="mt-6 grid gap-6 lg:grid-cols-3">
        <div className="rounded-2xl border border-slate-200 bg-white p-5 lg:col-span-2" data-testid="recent-registrations">
          <div className="mb-3 flex items-center justify-between">
            <h3 className="font-heading font-semibold text-slate-900">Recent registrations</h3>
            <Link to="/admin/restaurants" className="text-sm font-medium text-emerald-600 hover:underline">View all</Link>
          </div>
          {s.recent_registrations.map((r) => (
            <div key={r.id} className="flex items-center justify-between border-t border-slate-100 py-2.5 text-sm">
              <span className="font-medium text-slate-800">{r.name}</span>
              <span className="flex items-center gap-3 text-xs text-slate-400">{r.created_at && format(new Date(r.created_at), "dd MMM")}<StatusBadge status={r.status} /></span>
            </div>
          ))}
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="plan-distribution">
          <h3 className="mb-3 font-heading font-semibold text-slate-900">Plan distribution</h3>
          {Object.entries(s.plan_distribution).map(([k, v]) => (
            <div key={k} className="flex justify-between border-t border-slate-100 py-2.5 text-sm"><span>{k}</span><b>{v}</b></div>
          ))}
        </div>
      </div>
    </div>
  );
}
